import { get } from 'lodash/get'
import { handleError } from 'helper/rest'
import { clientPublic } from 'helper/axios'
let resError = ''
export const GET_DATA_ACCOUNT_BY_ID = async ({ id, token }) => {
  try {
    return await clientPublic
      .get(`account/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}
export const POST_ACCOUNT_PASSWORD = async ({ params, token }) => {
  try {
    return await clientPublic
      .post(`account/chgpass`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        resError = response
        const Error = get(response, 'data', '')
        return Error
      })
  } catch (error) {
    console.error('error', error)
    return resError
  }
}
export const POST_ACCOUNT_ROLE = async ({ params, token }) => {
  try {
    return await clientPublic
      .post(`account/role/${params.id}`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return resError
  }
}
export const POST_ACCOUNT_IMAGE = async ({ params, token }) => {
  try {
    return await clientPublic
      .post('account/image', params, {
        headers: {
          Authorization: `Bearer ${token}`,
          'content-type': 'multipart/form-data',
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}
